import type { HTMLAttributes } from 'react';
import { cn } from '../lib/utils.js';

/**
 * Loading placeholder (audit F8: loading was blank). Pulse only when motion
 * is allowed — the global reduce-motion utility handles the rest.
 */
export function Skeleton({ className, ...rest }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      aria-hidden="true"
      className={cn('animate-pulse rounded-xl bg-fg/10', className)}
      {...rest}
    />
  );
}
